const locale ={
    HELP :"እርዳታH",
    PRIVACY:"የግል ሚስጥር",
    TERMS:"አጠራር",
}

export default locale